import Component from '../core/Component'
import GoogleMapsLoader from 'google-maps'
import { GOOGLE_MAPS_API_KEY } from '../core/config'
import 'gmaps-marker-clusterer'
import { createMarker } from './Marker'
import EventBus from '../core/EventBus'


GoogleMapsLoader.KEY = GOOGLE_MAPS_API_KEY

// MAKE AS https://codepen.io/smhigley/pen/jifrK
export default class DealersMap extends Component {

    constructor(element) {
        super(element)

        this.markers = []
        this.cache = {}

        this.google = null
        this.cluster = null

        this.clusterOptions = {
            cssClass: 'Cluster',
            width: 36,
            height: 36,
            minimumClusterSize: 5
        }

        GoogleMapsLoader.load(::this.handleGoogleMapsLoad)

        this.infoWindow = null

        this._onMarkerClick = id => {}
    }

    prepare() {}

    handleGoogleMapsLoad(google) {
        this.google = google
        this.map = new google.maps.Map(this.element, {
            //center: latlng,
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"all","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#8aa49f"},{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"visibility":"on"},{"gamma":"3.32"}]},{"featureType":"landscape.natural.landcover","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"transit.station","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]}]
        })

        this.map.addListener('bounds_changed', ::this.handleBoundsChange)

        this.points = JSON.parse(this.element.dataset.points)

        this.show(this.points)
    }

    handleBoundsChange() {
        if (this.infoWindow) {
            this.infoWindow.close()
        }
    }

    show(points) {
        if (points.length === 0) {
            return
        }

        const google = this.google
        const Marker = createMarker(google)

        this.points = points

        this.markers = points.map(point => {
            const latlng = new google.maps.LatLng(point.lat, point.lng)

            const marker = new Marker({
                position: latlng,
                map: this.map,
                data: {
                    ...point
                },
                onClick: markerInstance => {
                    // this.showInfoWindow(markerInstance)
                    this._onMarkerClick(markerInstance)
                    this.emit('marker:click', {point: point})
                    EventBus.emit('marker:click', {point: point})
                }
            })

            return marker
        })

        this.cache = this.markers.reduce((acc, marker, index) => {
            acc[marker.options.data.id] = index
            return acc
        }, {})

        this.render()
    }

    render() {
        if (!this.google) {
            return
        }

        if (this.markers.length === 0) {
            return
        }

        this.cluster = new MarkerClusterer(this.map, this.markers, this.clusterOptions)

        this.fit()
    }

    fit() {
        const latitudes = this.points.map(point => point.lat)
        const longitudes = this.points.map(point => point.lng)

        const minLat = Math.min(...latitudes)
        const maxLat = Math.max(...latitudes)

        const minLng = Math.min(...longitudes)
        const maxLng = Math.max(...longitudes)

        const southWest = new google.maps.LatLng(minLat, minLng)
        const northEast = new google.maps.LatLng(maxLat, maxLng)

        const bounds = new google.maps.LatLngBounds(southWest, northEast)

        this.map.fitBounds(bounds)
    }

    focus(id) {
        if (id in this.cache) {
            const index = this.cache[id]
            const marker = this.markers[index]
            const latlng = marker.getPosition()
            this.map.setZoom(14)
            this.map.panTo(latlng)
            this.showInfoWindow(marker)
        }
    }

    showInfoWindow(marker) {
        const InfoBox = createInfoBox(this.google)

        const data = marker.options.data

        const web = data.web ? `<a href="${data.web}" class="Link">${data.web}</a>` : null
        const email = data.email ? `<a href="mailto:${data.email}" class="Link">${data.email}</a>` : null
        const city = [data.zip, data.city].filter(item => item).join(' ')
        const contacts = [web, email, data.phone].filter(item => item).join('<br>')

        let content =`
            <div class="store-Card">
                <h3 class="store-Card-title">
                    ${data.name}
                </h3>
                <p class="store-Card-info">
                    ${[data.street, city].filter(item => item).join('<br>')}
                </p>
        `

        if (contacts) {
            content += `<p class="store-Card-contats">${contacts}</p>`
        }

        content += '</div>'

        const infowindow = new InfoBox({
            position: marker.options.position,
            map: this.map,
            content: content
        })

        if (this.infoWindow) {
            this.infoWindow.close()
        }

        this.infoWindow = infowindow

        infowindow.open()
    }

    onMarkerClick(callback) {
        this._onMarkerClick = callback
    }

}